import type {
  MediaImageInterface,
  TeaserCardProps
} from '@hypercodestudio/basler-components';

import type { AlgoliaContentfulPage } from '~~/lib/AlgoliaService/models/AlgoliaContentfulPage';
import { generateImageObject } from '~/utils/generateImageObject';
import { DETAILED_TAG } from '~/utils/shop/constants';
import { rewriteContentfulAssetUrlForLocale } from '~/utils/contentful/rewriteContentfulAssetHostsByLocale';
import { teaserCardImageOptions } from '~/utils/imagePresetRegistry';

export function transformAlgoliaContentfulPageToTeaserCard(
  page: Pick<
    AlgoliaContentfulPage,
    | 'teaser_image_url'
    | 'teaser_image_alt'
    | 'teaser_description'
    | 'teaser_title'
    | 'url'
    | 'detailed_topics'
    | 'date'
  >,
  locale: string,
  showDate?: boolean | undefined
): TeaserCardProps {
  const rewrittenTeaserImageUrl = rewriteContentfulAssetUrlForLocale(
    page.teaser_image_url ?? '',
    locale
  );
  const image = generateImageObject(rewrittenTeaserImageUrl, {
    ...teaserCardImageOptions,
    originalWidth: 1600,
    originalHeight: 900
  });
  if (image) {
    (image.content as MediaImageInterface).alt = page.teaser_image_alt;
  }

  return {
    header: image,
    content: page.teaser_description,
    date:
      showDate && page.date
        ? {
            date: new Date(page.date).toLocaleDateString(locale),
            dateIso: page.date
          }
        : undefined,
    link: buildLinkInterface(page.url, locale),
    headline: page.teaser_title,
    tagList: {
      isNotWrapped: false,
      isSmall: true,
      tags: page.detailed_topics?.map((tag) => ({
        text: tag.split(DETAILED_TAG)[0]
      }))
    }
  };
}
